import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/q/:question',
      name: 'question',
      component: () => import(
        './views/Question.vue'
      )
    },
    {
      path: '/end',
      name: 'end',
      component: () => import(
        './views/Congrats.vue'
      )
    },
    {
      path: '/conditions',
      name: 'conditions',
      component: () => import(
        './views/Terms.vue'
      )
    }
  ]
})
